import {Breadcrumb, Tabs} from 'src/feature/bite/component'

import {
  EmailEngagement,
  MemberDetailConsents,
  MemberDetailOverview,
  MemberDetailTransactions,
  MemberDetailPackages,
  MemberDetailActivities,
} from '../component/Detail'

import {useIntl} from 'react-intl'
import {useGetDetail, useGetTabDetail} from '../context/useQuery'
import {useMember} from '../hook'
import {useEffect, useState} from 'react'
import {Link, useSearchParams} from 'react-router-dom'

export default function MemberDetail() {
  const intl = useIntl()
  const [queryParameters] = useSearchParams()

  const getuserIDParam = () => {
    const path = window.location.pathname
    const pathParts = path.split('/')
    const userID = pathParts[pathParts.length - 1]
    return userID
  }

  const {isLoading: isLoadingTab} = useGetTabDetail(getuserIDParam())
  const {tabName, tabNameSet, detail, listFilterTrx, listFilterSetTrx} = useMember()
  const {isLoading} = useGetDetail(getuserIDParam())
  const [search, setSearch] = useState('')

  const tabs = [
    {
      label: intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW'}),
      key: 'Overview',
      component: <MemberDetailOverview />,
    },
    {
      label: intl.formatMessage({id: 'MEMBER.DETAIL.CONSENTS'}),
      key: 'Consent',
      component: <MemberDetailConsents />,
    },
    {
      label: 'Memberships/Products',
      key: 'Packages',
      component: (
        <MemberDetailPackages loading={isLoadingTab} search={search} setSearch={setSearch} />
      ),
    },
    {
      label: intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS'}),
      key: 'Transaction',
      component: (
        <MemberDetailTransactions loading={isLoadingTab} search={search} setSearch={setSearch} />
      ),
    },
    {
      label: intl.formatMessage({id: 'MENU.ACTIVITIES'}),
      key: 'Activities',
      component: (
        <MemberDetailActivities
          loading={false}
          search={search}
          setSearch={setSearch}
          customerID={detail?.customerID || ''}
        />
      ),
    },
    /*     {
      label: intl.formatMessage({id: 'MEMBER.DETAIL.EMAIL_ENGAGEMENT'}),
      key: 'EmailEngagement',
      component: <EmailEngagement loading={isLoadingTab} />,
    }, */
  ]

  function findSelectedTab(tabs: any[], selectedTab: string) {
    for (const tab of tabs) {
      if (tab.key === selectedTab) {
        return tab
      } else if (tab.childs) {
        const selectedChildTab = findSelectedTab(tab.childs, selectedTab)

        if (selectedChildTab) {
          return selectedChildTab
        }
      }
    }
    return null
  }

  useEffect(() => {
    const tabParameter = queryParameters.get('tab')

    if (tabParameter) {
      const selectedTab = tabs.find((tab) => tab.key === tabParameter) as any

      if (selectedTab && selectedTab.key !== tabName) {
        tabNameSet(selectedTab.key)
      } else {
        tabNameSet('Overview')
      }
    }
  }, [])

  return (
    <>
      <Breadcrumb
        parentPage={intl.formatMessage({id: 'MEMBER_PLURAL'})}
        currentPage={intl.formatMessage({id: 'MEMBER.DETAIL'})}
      />

      <div className='card mb-5 mb-xl-10 mt-10'>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap'>
            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div className='d-flex flex-column w-lg-30'>
                  <div className='page-title d-flex justify-content-between gap-5 me-3 align-items-center'>
                    <h1 className='page-heading d-flex flex-column justify-content-center text-dark fw-bold fs-3 m-0'>
                      {detail && detail.name && detail.surname
                        ? `${detail.name} ${detail.surname}`
                        : ''}
                    </h1>
                    {detail?.vipTier && (
                      <div className='d-flex align-items-center gap-2'>
                        <span className='fs-5 fw-semibold'>
                          {intl.formatMessage({id: 'VIP.LABEL.STATUS'})}:
                        </span>
                        <div
                          className='d-flex align-items-center gap-2 badge-success-badge py-1 px-10 rounded-pill'
                          style={{
                            backgroundColor: '#ff6933',
                          }}
                        >
                          <span className='fs-5 text-white'>
                            {detail?.vipTier} {intl.formatMessage({id: 'MEMBER_SINGLE'})}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Tabs tabs={tabs} selectedTab={tabName} setSelectedTab={tabNameSet} loading={isLoading} />
        </div>
      </div>

      <div className='tab-content' id='myTabContent'>
        <div className='tab-pane fade active show' role='tabpanel'>
          <div className='card-body pt-0'>
            <div className='tab-content' id='myTabContent'>
              {findSelectedTab(tabs, tabName)?.component}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
